import cardResource from "@/shared/resource/card";
import { authorizedAxios } from "./authorizedAxios";
import { FiservCodeMappingRequest, FiservCodeMappingResponse } from "@/admin/types";

export function getFiservCodeMappings () {
    return authorizedAxios.get<FiservCodeMappingResponse[]>(cardResource.fiservCodeMappings());
}

export function getFiservCodeMapping (fiservCodeMappingId: number) {
    return authorizedAxios.get<FiservCodeMappingResponse>(cardResource.fiservCodeMapping(fiservCodeMappingId));
}

export function createFiservCodeMapping (fiservCodeMappingRequest: FiservCodeMappingRequest) {
    return authorizedAxios.post<FiservCodeMappingResponse>(cardResource.fiservCodeMappings(), fiservCodeMappingRequest);
}

export function updateFiservCodeMapping (fiservCodeMappingId: number, fiservCodeMappingRequest: FiservCodeMappingRequest) {
    return authorizedAxios.put<FiservCodeMappingResponse>(cardResource.fiservCodeMapping(fiservCodeMappingId), fiservCodeMappingRequest);
}

export function deleteFiservCodeMapping (fiservCodeMappingId: number) {
    return authorizedAxios.delete<FiservCodeMappingResponse>(cardResource.fiservCodeMapping(fiservCodeMappingId));
}